import React, { useState } from "react";
import PropTypes from "prop-types";
import { getData, getCompanyList } from "../../../../serverRequest";
import LoadingSpinner from "../../../../components/Loadder";
import moment from 'moment';
import ProductListTable from "../../../../components/Tables/ProductListTable";
import { Link } from 'react-router-dom';
import Select from 'react-select';

export default function ProductList() {
    const [open, setOpen] = React.useState(true);
    const [totalProducts, setTotalProducts] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const searchParams = new URLSearchParams(window.location.search);
    const [companies, setCompanies] = useState([]);
    const [companyData, setCompanyData] = useState();
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(1);

    const handleChange = selectedOption => {
        console.log(selectedOption);
        
        setSelectedCompany(selectedOption.value);
        setCompanyData(selectedOption.value);
        setSelectedOption(selectedOption);
    };

    async function fetchData() {
        setLoading(true);
        let resData = await getData('/api/product/bizproduct?company_id=' + selectedCompany);
        if (resData && resData['data']) {
            let product_data = resData['data']['bizproduct_data'];
            console.log(product_data);
            await filterProductData(product_data);
            setLoading(false);
        }

        
    }

    React.useEffect(() => {
        fetchData();
    }, [selectedCompany]);

    const fetchCompanyData = async () => {
        let companyList = await getCompanyList();
        if (companyList && companyList['data']) {
            companyList = companyList['data']
            let companyData = companyList[0]['value']
            await setCompanyData(companyData);
            setCompanies(companyList);
            setSelectedOption(companyList[0]);
        }
    }

    React.useEffect(() => {
        
        fetchData();

        fetchCompanyData()
    }, [])

    const ticketFilter = searchParams.get('filter');
    //console.log(ticketFilter);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const formatDate = (dateString) => {
        return moment(dateString).format('DD/MM/YYYY');
    };

    const filterProductData = async (products_data) => {
        let totalproduct = [];
        if (products_data) {
            for (let i = 0; i < products_data.length; i++) {
                totalproduct.push(products_data[i]);
            }
        }

        await setTotalProducts(totalproduct);
        return { "total": totalproduct };
    }
    
    return (
        <>

            <main>
                <div className="relative block py-24 lg:pt-0 px-4">
                    <div className="rounded-t bg-white mb-0 px-6 py-6">
                        <div className="text-center flex justify-between">
                            <h6 className="text-blueGray-700 text-xl font-bold">Products</h6>
                            <div className="w-full lg:w-4/12 px-4">
                                <div className="relative w-full">
                                    <Select name="clist" options={companies} value={selectedOption} onChange={handleChange} placeholder="Select Entity" />
                                </div>
                            </div>
                            <Link to="/admin/inventory/productForm">
                                <button
                                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                    type="button"
                                >
                                    Product
                                </button>
                            </Link>
                        </div>
                    </div>
                    {loading ? (
                        <LoadingSpinner></LoadingSpinner>
                    ) : (<>
                        <div
                            className={
                                "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                                ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
                            }
                        >

                            <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                                {/* Projects table */}
                                <ProductListTable totalProducts={totalProducts}></ProductListTable>

                            </div>
                        </div>
                    </>)}
                </div>
            </main>

        </>
    );
}
